var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoomControlCenter = function SvgZoomControlCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.758,
    height: 13.758,
    viewBox: "0 0 13.758 13.758",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M287.674,5.1h3.075a.728.728,0,0,0,.515-1.243l-1.071-1.071L292.046.933a.546.546,0,0,0-.773-.773l-1.852,1.853L288.35.942a.728.728,0,0,0-1.243.515V4.533a.58.58,0,0,0,.567.567",
    transform: "translate(-278.469)",
    fill: "#575b5e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M4.552,287.1h-3.1a.728.728,0,0,0-.515,1.243l1.071,1.071L.16,291.27a.546.546,0,0,0,0,.773.489.489,0,0,0,.386.181.544.544,0,0,0,.386-.16l1.852-1.853,1.071,1.071a.728.728,0,0,0,1.243-.515v-3.117a.559.559,0,0,0-.546-.546",
    transform: "translate(0 -278.465)",
    fill: "#575b5e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M4.651.787a.773.773,0,0,0-.28-.076.728.728,0,0,0-.515.214L2.785,2.015.934.163A.546.546,0,0,0,.161.935L2.013,2.788.943,3.859A.728.728,0,0,0,1.458,5.1H4.533a.525.525,0,0,0,.526-.526V1.46A.639.639,0,0,0,4.651.787",
    transform: "translate(0 -0.002)",
    fill: "#575b5e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M292.858,290.367l1.071-1.071a.728.728,0,0,0-.515-1.243h-3.075a.524.524,0,0,0-.526.526v3.076a.728.728,0,0,0,1.243.515l1.07-1.071,1.852,1.853a.352.352,0,0,0,.345.2.546.546,0,0,0,.386-.933Z",
    transform: "translate(-281.111 -279.393)",
    fill: "#575b5e"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomControlCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-control-center.9a085b63.svg";
export { ForwardRef as ReactComponent };